export default __webpack_public_path__ + "616fc44ab3dad7a0ac2e461b95d6a1bf.png";